import { styled } from "@mui/material/styles";
import { SubTitleProps } from "./types";
import { Typography } from "@mui/material";

export const SubTitle = ({ text, icon, onClickHandler, className }: SubTitleProps) => {
  return (
    <StyledSubTitle onClick={onClickHandler} className={className}>
      {icon}
      <Typography component="span" color="gray.66" fontWeight={700}>
        {text}
      </Typography>
    </StyledSubTitle>
  );
};

const StyledSubTitle = styled("div")(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  padding: "0.75rem 1.5rem",
  fontFamily: "'Nunito', sans-serif",
  svg: {
    fill: theme.tokens.colors.gray[6],
    paddingRight: "0.5rem",
  },
  span: {
    fontFamily: "'Nunito', sans-serif",
  },
  "&:hover": {
    svg: { fill: theme.tokens.colors.gray[7] },
    background: theme.shapeTheme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
  },
}));
